<template lang="pug">
Card(
  :pages="pagination",
  @page="updateConfig('page', $event)",
)
  .loading(v-if="state === 'loading'"): i.mdi.mdi-loading.mdi-spin
  .no-items(v-else-if="orders.length === 0")
    p {{ $t('products.no_orders') }}
  table(v-else)
    tr
      th.amount-col-header {{ $t('ticket.amount') }}
      th.status-col-header
      th
      th.customer-col-header {{ $t('ticket.customer') }}
      th {{ $t('ticket.date') }}
    template(v-for="order in orders")
      tr(:key="order.id", @click="openOrder(order.id)")
        td.amount {{ order.formated_total_amount }}
        td.status-col: Tag(:text="$t(`products.status_${order.status}`)", :icon="`${order.status === 'fulfilled' ? 'check' : '' }`", :class="`capitalize ${order.status === 'waiting' || order.status === 'created' ? 'gray' : ''} ${order.status === 'fulfilled' ? 'green' : ''} ${order.status === 'failed' || order.status === 'cancelled' ? 'red' : ''}`")
        td: Tag(:text="numItems(order.items).toString()" icon="package-variant-closed")
        td {{ order.shipping ? order.shipping.name : '' }}
        td.date-col
          .large {{ order.created_at | formatDate('lll') }}
          .small {{ order.created_at | formatDate('ll') }}
      tr(v-if="currentOrder !== null && currentOrder.id === order.id", :key="`${order.id}-info`")
        td(colspan="5").order-info
          div
            ovp-row(gutter="20")
              ovp-column.no-child-flex(flex="1")
                .p-b-2
                  table.items-table
                    tr
                      th.product-name {{ $t('products.product') }}
                      th {{ $t('products.price_per') }}
                      th {{ $t('products.quantity') }}
                      th {{ $t('products.sum') }}
                    tr(v-for="item in currentOrder.items", :key="item.product_sku_id")
                      td {{ item.description }}
                      td {{ item.formated_amount }}
                      td {{ item.quantity }}st
                      td {{ item.formated_total_amount }}
                  .d-f.items-sum
                    .ml-a.m-t-2 {{ currentOrder.formated_total_amount}}
              ovp-column.no-child-flex(flex="1")
                .p-a-2(v-if="currentOrder.shipping")
                  .d-f
                    .f-1
                      label.m-b-1 {{ $t('common.name') }}
                      p {{ currentOrder.shipping.name }}
                    .f-1
                      label.m-b-1 {{ $t('common.phone') }}
                      p {{ currentOrder.shipping.phone }}
                  .d-f.m-t-2
                    .f-1
                      label.m-b-1 {{ $t('common.address') }}
                      p {{ currentOrder.shipping.address.line1 }}
                    .f-1
                      label.m-b-1 {{ $t('common.postal_code') }}
                      p {{ currentOrder.shipping.address.postal_code }}
                    .f-1
                      label.m-b-1 {{ $t('common.city') }}
                      p {{ currentOrder.shipping.address.city }}
                  .d-f.m-t-2
                    .f-1
                      label.m-b-1 {{ $t('common.country') }}
                      p {{ currentOrder.shipping.address.country }}
            .fulfill.d-f(v-if="currentOrder.status === 'paid' || currentOrder.status === 'fulfilled'").m-t-4
              ovp-button(@click="fulfill.open = true", :disabled="fulfill.open === true", :class="`${currentOrder.status === 'fulfilled' ? 'success' : ''}`") {{currentOrder.status === 'fulfilled' ? $t('products.marked_as_fulfilled') : $t('products.mark_as_fulfilled') }}
              .carrier-info.f-w(v-if="fulfill.open")
                small {{ $t('products.additional_postal_information') }}
                label.m-t-2 {{ $t('products.carrier') }}
                ovp-input(:placeholder="$t('products.carrier_example')", v-model="fulfill.carrier")
                label.m-t-2 {{ $t('products.tracking_number') }}
                ovp-input(:placeholder="$t('products.tracking_number_example')", v-model="fulfill.tracking")
                .d-f.m-t-2
                  ovp-button(:icon="fulfillState === 'fulfilling' ? 'loading mdi-spin' : null", @click="fulfillState === '' ? markAsFulfilled() : null").mr-a {{ $t('products.mark_as_fulfilled') }}
                  ovp-button.medium.secondary(@click="fulfill.open = false;", :disable="fulfillState === 'fulfilling'") {{ $t('common.cancel') }}

</template>

<script>

import moment from 'moment';
// import Card from '@/components/card-advanced.vue';
import Tag from '@/components/tag.vue';

export default {
  components: {
    Card,
    Tag,
  },
  props: {

  },
  computed: {
    /**
     * Return the baseurl for images in list
     * @return {String}
     */
    resourceBaseURL() { return `https://${this.$store.getters['AccountManager/account'].fqdn}/images/75x75/`; },
    /**
     * The orders in store
     * @return {Array}
     */
    orders() {
      return this.$store.getters['Products/orders'];
    },
    /**
     * Current state of orders
     * @return {String}
     */
    state() {
      return this.$store.getters['Products/ordersState'];
    },
    /**
     * Pagination for the orders list
     * @return {Object}
     */
    pagination() {
      return this.$store.getters['Products/ordersPagination'];
    },
    /**
     * Current configuration for orders list
     * @return {Object}
     */
    config() {
      return this.$store.getters['Products/ordersConfig'];
    },
  },
  methods: {
    /**
     * Get and return the number of products the order contains
     * @param {Array} items
     * @returns {String}
     */
    numItems(items) {
      let num = 0;
      items.forEach((item) => {
        num += item.quantity;
      });
      return num;
    },
    /**
     * Update the config with key and value
     */
    updateConfig(key, value) {
      const payload = {};
      /*if (key === 'searchParam') {
        const { paramKey, paramValue } = value;
        payload.id = paramKey === 'id' ? paramValue : '';
      } else {*/
      payload[key] = value;
      //}

      if (key !== 'page') {
        payload.page = 1;
      }

      this.$store.dispatch('Products/updateOrdersConfig', payload);
      this.fetchOrders();
    },
    /**
     * Fetch transactions that places them in store
     */
    fetchOrders(skipLoading = false) {
      this.$store.dispatch('Products/getOrders', { skipLoading });
    },
    /**
     * Fetch single order
     * @param {String} id
     * @returns {?Object}
     */
    async fetchOrder(id) {
      const order = await this.$store.dispatch('Products/getOrder', id);
      return order;
    },
    /**
     * Open a order
     * @param {String} id
     */
    async openOrder(id) {
      const { currentOrder } = this;
      if (!currentOrder || currentOrder.id !== id) {
        const order = await this.fetchOrder(id);
        if (!order) {
          return;
        }
        this.currentOrder = order;

        this.fulfill = {
          open: false,
          tracking: order.tracking,
          carrier: order.carrier,
        };

        return;
      }
      this.currentOrder = null;
      this.fulfill = null;
    },
    /**
     * Mark an order as fulfilled
     */
    async markAsFulfilled() {
      const {
        fulfill: {
          tracking,
          carrier,
        },
        currentOrder: {
          id,
        },
      }  = this;

      this.fulfillState = 'fulfilling';
      const result = await this.$store.dispatch('Products/fulfillOrder', { tracking, carrier, id });
      this.fulfillState = '';

      if (!result) {
        return;
      }

      this.fulfill.open = false;
    }
  },
  data() {
    return {
      currentOrder: null,
      fulfillState: '',
      fulfill: null,
    };
  },
  mounted() {
    this.fetchOrders();
  },
  filters: {
    formatDate(value, dateString) {
      return moment(value).format(dateString);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../variables.sass';

.item-border-bottom {
  border-bottom: 1px solid rgba(black, .1);
}

.items-sum {
  border-top: 1px solid rgba(black, .5);
  font-weight: 500;
  font-size: 1.2rem;
}

table {
  border-spacing: 0;
  display: block;
  overflow-x: auto;
  position: relative;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, "Helvetica Neue", Ubuntu, sans-serif;

  &.items-table {
    display: table;
    th {
      width: 25%;
      text-transform: uppercase;
      padding-top: 8px;
    }
    td {
      width: 25%;
      border-top: 1px solid rgb(218, 218, 218);
    }
  }

  & > * {
    transform: translate3d(0, 0, 0);
  }
  th {
    color: $mutedColor;
    font-size: 12px;
    padding: 16px 10px 8px 10px;
    text-align: left;
    &.amount-col-header {
      text-align: right;
      width: 14%;
    }
    &.status-col-header {
      padding-right: 0;
    }
    &.product-col-header {
      width: 50%;
    }
    &.customer-col-header {
      width: 100%;
    }
    &.refund-col-header {
      text-align: right;
    }
  }
  & > tr {
    & > td {
      border-top: 1px solid #eee;
      padding: 10px;
      &.amount {
        font-weight: 500;
        text-align: right;
        &.grey {
          color: $mutedColor;
        }
      }
      &.status-col {
        text-align: left;
        padding-right: 0;
      }
      &.type-col {
        text-transform: capitalize;
      }
      &.date-col {
        font-size: .8rem;
        .large {
          display: none;
        }
        @media (min-width: 600px) {
          .small {
            display: none;
          }
          .large {
            display: block;
          }
        }
      }
    }
    &:hover, &.open {
      & > td:not(.transactionInfo) {
        cursor: pointer;
        background-color: rgba($mutedColor, .05);
      }
    }
  }
}

.order-info {
  background-color: rgba($mutedColor, .05);
  cursor: auto;
  label {
    color: $mutedColor;
    font-size: 12px;
  }
}

.fulfill {
  position: relative;

  .carrier-info {
    position: absolute;
    width: 350px;
    background-color: white;
    bottom: 40px;
    z-index: 100;
    left: 0;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #a8a8a8;

    small {
      white-space: normal;
      font-size: .8rem;
      font-weight: 500;
      color: #7b7b7b;
      text-align: center;
      display: block;
    }

    &:after, &:before {
      top: 100%;
      left: 85px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #FFFFFF;
      border-width: 10px;
      margin-left: -10px;
    }
    &:before {
      border-color: rgba(168, 168, 168, 0);
	    border-top-color: #a8a8a8;
      border-width: 11px;
      margin-left: -11px;
    }
  }
}
</style>
